module.exports = __webpack_public_path__ + "static/img/temp1.38f9bdc8.png";